import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EventEmitterService } from '../../services/event-emitter.service';
import { ThirdpartyService } from '../../services/thirdparty.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-third-party-popup',
  templateUrl: './third-party-popup.component.html',
  styleUrl: './third-party-popup.component.scss',
})
export class ThirdPartyPopupComponent implements OnInit {
  title;
  type = '';
  formGroup: FormGroup;
  thirdParty;
  weekdays = [];
  disableButton = false;

  constructor(
    public bsModalRef: BsModalRef,
    private thirdpartyService: ThirdpartyService,
    private eventEmitterService: EventEmitterService,
    private translateService: TranslateService,
  ) {}

  async ngOnInit() {
    this.setupWeekdays();
    this.setupForm();
  }

  setupWeekdays() {
    this.weekdays = [
      { id: 'monday', name: this.translateService.instant('monday') },
      { id: 'tuesday', name: this.translateService.instant('tuesday') },
      { id: 'wednesday', name: this.translateService.instant('wednesday') },
      { id: 'thursday', name: this.translateService.instant('thursday') },
      { id: 'friday', name: this.translateService.instant('friday') },
      { id: 'saturday', name: this.translateService.instant('saturday') },
      { id: 'sunday', name: this.translateService.instant('sunday') },
    ];
  }

  setupForm() {
    let offDays = [];
    if (this.thirdParty && this.thirdParty.off_days) {
      if (typeof this.thirdParty.off_days === 'string') {
        const parsedDays = JSON.parse(this.thirdParty.off_days);
        offDays = this.weekdays.filter((w) => parsedDays.includes(w.id));
      } else {
        offDays = this.weekdays.filter((w) =>
          this.thirdParty.off_days.includes(w.id),
        );
      }
    }

    this.formGroup = new FormGroup({
      name: new FormControl(
        this.thirdParty ? this.thirdParty.name : '',
        Validators.required,
      ),
      email: new FormControl(this.thirdParty ? this.thirdParty.email : '', [
        Validators.required,
        Validators.email,
      ]),
    });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  setOffDays(event) {
    if (event.value && Array.isArray(event.value)) {
      this.formGroup.get('off_days').setValue(event.value);
    }
  }

  buttonClicked() {
    this.formGroup.markAllAsTouched();

    if (this.formGroup.invalid) {
      return;
    }

    const formValue = { ...this.formGroup.value };
    if (formValue.off_days && Array.isArray(formValue.off_days)) {
      formValue.off_days = formValue.off_days.map((day) => day.id);
    }

    if (this.disableButton == true) {
      return;
    }
    this.disableButton = true;

    if (this.type === 'new-third-party') {
      this.thirdpartyService.createThirdParty(formValue).subscribe(
        (response) => {
          console.log('response:');
          console.log(response);
          this.eventEmitterService.callAllThirdParties();
          this.closeModal();
          this.disableButton = false;
        },
        (error) => {
          console.log('error:');
          console.log(error);
          this.disableButton = false;
        },
      );
    }
    if (this.type === 'edit-third-party') {
      this.thirdpartyService
        .updateThirdParty(this.thirdParty.id, formValue)
        .subscribe(
          (response) => {
            console.log('response:');
            console.log(response);
            this.eventEmitterService.callAllThirdParties();
            this.closeModal();
            this.disableButton = false;
          },
          (error) => {
            console.log('error:');
            console.log(error);
            this.disableButton = false;
          },
        );
    }
  }
}
